import { INofeshUploads } from './../../nofesh/model/nofesh-uploads';
import { INofshonNirshamim } from './../model/nofshon-nirshamim';
import { INirsham } from 'app/nofesh/model/nirsham';
import { NofshonimService } from 'app/nofshonim-chul/nofshonim.service';
import { INofesh } from './../../nofesh/model/nofesh';
import { ITashlum } from './../../nofesh/model/tashlum';
import { FormArray, FormControl } from '@angular/forms';


import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { AppSettings } from "../../shared/app-settings";
import { MenuHandler } from "app/shared/menu-handler";
import { INofeshSelected } from '../../shared/interfaces/Inofesh-selected.interface';
import { INofshonNirsham } from '../model/nofshon-nirsham';
import { ConfigService } from 'app/shared/config.service';
import { ENofeshType } from 'app/shared/enums/enofesh-type.enum';
import { NofshonReservationTimerService } from 'app/shared/timer/nofshon-reservation-timer.service';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { NofeshService } from 'app/nofesh/nofesh.service';
import { Subscription } from 'rxjs';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { MatDialog, MatSnackBarRef } from '@angular/material';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog/confirm-dialog.component';
declare var $: any;


@Component({
    moduleId: module.id,
    templateUrl: 'end-rishum.component.html'
})
export class NofshonChulEndRishumComponent implements OnInit, OnDestroy {
    form: FormGroup;
    uploadsNeeded: INofeshUploads[];
    nirshamim: INofshonNirsham[];
    tashlumim: ITashlum[];
    nofesh: INofesh;
    nofesh_id: number;
    sum_tashlumim: number;
    is_submit: boolean;
    is_hamtana: boolean = false;
    is_nofesh_full: boolean;
    is_edit_mode: boolean;
    nofeshAgreementsFileUrl: string;//= `${this.apiUrl}/UploadFiles/NofeshAgreements/`; 
    amitim_count: number = 1;
    ms_zehut_mazmim: number;
    nofesh_tentativi: number;
    moed_rishum: string;
    nofesh_type: number;
    apiUrl: string = "";
    uploadsNeededForPassportValidation: INofeshUploads[] = [];
    isPassportValidMoreThanSixMonths: boolean = true;
    userSelectedNofesh: INofeshSelected;
    private _timeoutSubscription: Subscription;
    nofeshTypes: typeof ENofeshType = ENofeshType;
    snackBarRef: MatSnackBarRef<any>;

    constructor(
        private _router: Router,
        private fb: FormBuilder,
        private _configService: ConfigService,
        private _nofshonimService: NofshonimService,
        private _nofeshService: NofeshService,
        private _nofshonReservationTimerService: NofshonReservationTimerService,
        private _userMessagesService: UserMessagesService,
        private _confirmDialogService: ConfirmService,
        private _confirmDialog: MatDialog
    ) {
        this.apiUrl = this._configService.getConfigPropertyByKey("apiUrl");
        this.nofeshAgreementsFileUrl = `${this.apiUrl}/UploadFiles/NofeshAgreements/`;

        this.form = this.fb.group({
            userDeclaration: ['', [Validators.required, CustomValidators.gt(0)]],
            userResponsibility: ['', [Validators.required, CustomValidators.gt(0)]],
            //lawyerDeclaration: ['', [Validators.required, CustomValidators.gt(0)]],
            smsDeclaration: ['', [Validators.required, CustomValidators.gt(0)]],
            adifutDeclaration: ['', [Validators.required, CustomValidators.gt(0)]],
            covidDeclaration: ['', [Validators.required, CustomValidators.gt(0)]]
        });
    }

    async ngOnInit() {
        MenuHandler.menuHandler($(".wiz_group"), $("#li_siyum"));
        window.scrollTo(0, 0);
        let orderNofesh: INofshonNirshamim = JSON.parse(sessionStorage.getItem('nofshon-nirshamim'));

        this.userSelectedNofesh = JSON.parse(sessionStorage.getItem('userSelectedNofesh'));
        if (!this.userSelectedNofesh) {
            this.userSelectedNofesh = await this._nofeshService.getUserSelectedNofesh(this.nofesh_id).toPromise();
            debugger
            if (!this.userSelectedNofesh) {
                console.error("Unable to complete reservation. Mandatory data is missing.");
                this.navigateToNofeshPage()
                return;
            }
        }

        if (this.userSelectedNofesh.isReservationCompleted) {
            this._onInitCompletedReservation();
        }
        else if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh)) {
            const reservationExpiration = this._nofshonReservationTimerService.getReservationExpiration(this.userSelectedNofesh.moed_rishum);
            const isExpired = this._nofshonReservationTimerService.checkIfTimerTimedOut(reservationExpiration);
            if (isExpired) {
                console.log("End rishum - navigating to home on timeout");
                this.navigateToNofeshPage();
                return;
            }
            else {
                this._nofshonReservationTimerService.resumeTimer(reservationExpiration);
                this._timeoutSubscription = this._nofshonReservationTimerService.timerTimeout$.subscribe((timeout: boolean) => {
                    console.log("End rishum - timer notified. Is timeout?", timeout);
                    if (timeout) {
                        console.log("End rishum - navigating to home on resumed timeout");
                        this.navigateToNofeshPage();
                    }
                });
            }
        }

        // if (this.userSelectedNofesh.nofesh_type === ENofeshType.NofeshPnim || this.userSelectedNofesh.nofesh_type === ENofeshType.MeurganimPnim) {
        //     this.form.addControl("greenPassPnim", new FormControl("", [Validators.required, CustomValidators.gt(0)]));
        // }
         if (this.userSelectedNofesh.nofesh_type === ENofeshType.NofeshChul || this.userSelectedNofesh.nofesh_type === ENofeshType.MishpachotChul) {
            this.form.addControl("greenPassChul", new FormControl("", [Validators.required, CustomValidators.gt(0)]));
            this.form.addControl("lawyerDeclaration", new FormControl("", [Validators.required, CustomValidators.gt(0)]));
        }

        if (orderNofesh == null) {
            this.nofesh_id = this.userSelectedNofesh.id_nofesh;
            this.ms_zehut_mazmim = JSON.parse(sessionStorage.getItem('ms_zehut_mazmin'));

            this.nirshamim = await this._nofshonimService.getPirteyNofshim(this.nofesh_id).toPromise();
            if (!this.nirshamim) {
                this._userMessagesService.setErrorMessage("אירעה שגיאה בטעינת הנתונים");
                this.navigateToNofeshPage();
                return;
            }
        }
        else {
            this.nofesh_id = orderNofesh.nirshamim[0].id_nofesh;
            this.ms_zehut_mazmim = orderNofesh.nirshamim[0].ms_zehut;
            this.nirshamim = orderNofesh.nirshamim;
        }

        this._nofshonimService.getPirteyNofshim(this.nofesh_id).subscribe(r => {
            if (r) {
                this.is_hamtana = r[0].is_hamtana;
                this.amitim_count = r.filter(t => t.is_amit > 0).length;
                if (this.amitim_count > 1) {
                    this.form.addControl('amitNosafDeclaration', new FormControl('', [Validators.required, CustomValidators.gt(0)]));
                }
                if (this.nirshamim == null) {
                    this.nirshamim = r;
                }
            }
        });

        if (this.userSelectedNofesh.id_nofesh > 0) {
            this.is_edit_mode = true;
            this.moed_rishum = this.userSelectedNofesh.moed_rishum.toString();
        }
        else {
            let moed_rishum = sessionStorage.getItem('moed-rishum');
            if (moed_rishum != null) {
                this.moed_rishum = moed_rishum;
            }
        }

        this.nofesh = JSON.parse(sessionStorage.getItem('nofashim')).filter(t => t.id_nofesh == this.nofesh_id)[0];
        this.nofesh_type = this.nofesh.nofeshType;
        var payments = JSON.parse(sessionStorage.getItem('nofshon-tashlumim'));
        if (payments == null) {
            this._nofshonimService.getNofshonPayment(this.nofesh_id)
                .subscribe(res => {
                    payments = res.nofshonTashlumim;
                    this.tashlumim = payments;
                    let sum: number = 0;
                    payments.forEach(element => {
                        sum += element.schum_tashlum;
                    });
                    this.sum_tashlumim = sum;
                });
        }
        else {
            let sum: number = 0;
            payments.tashlumim.forEach(element => {
                sum += +element.schum_tashlum;
                if (element.ofen_tashlum == 1 && element.teur_tashlum == '') {
                    element.teur_tashlum = "ניכוי שכר";
                }
                else if (element.ofen_tashlum == 2 && element.teur_tashlum == '') {
                    element.teur_tashlum = "אשראי";
                }
            });
            this.sum_tashlumim = sum;
            this.tashlumim = payments.tashlumim;
        }

        if (this.nofesh_type < ENofeshType.NofeshChul) {
            this.uploadsNeeded = null;
        }
        else {
            this._nofshonimService.getNofshonUploads(this.nofesh_id)
                .subscribe(r => {
                    Object.assign(this.uploadsNeededForPassportValidation, r);
                    this.uploadsNeeded = r.filter(x => x.is_uploaded == false);
                    this.uploadsNeededForPassportValidation.forEach(element => {
                        if (element.doc_type == "צילום דרכון- תקף לחצי שנה") {
                            this.isPassportValidMoreThanSixMonths = false;
                        }
                    });
                });
        }
    }

    private _onInitCompletedReservation(): void {
        this.is_submit = this.userSelectedNofesh.isReservationCompleted;
        this._disableCheckedCheckboxes();
        window.scroll(0, 0);

        setTimeout(() => {
            this._showCompletedReservationMessage();
        }, 0);
    }

    private _disableCheckedCheckboxes(): void {
        for (let controlKey in this.form.controls) {
            const control = this.form.get(controlKey) as FormControl;
            control.patchValue(0);
            control.disable();
        }
    }

    navigateToNofeshPage(): void {
        this._router.navigate(["/nofesh"]);
    }

    submit() {
        this.is_submit = true;

        if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted && this._nofshonReservationTimerService.checkIfInMinimalPeriodToStopTimer(this.userSelectedNofesh.moed_rishum)) {
            this._nofshonReservationTimerService.stopTimer();
            this._nofshonReservationTimerService.hideTimer();
            console.log("End rishum - submit on minimal timer time. Timer is stopped");
        }

        this._nofshonimService.completeNofshonReservation(this.nofesh_id, this.is_hamtana, this.userSelectedNofesh.id_reservation)
            .subscribe((response: ResultOfOperation<boolean>) => {
                if (response.isSuccess) {
                    this.userSelectedNofesh.isReservationCompleted = response.data;
                    sessionStorage.removeItem("userSelectedNofesh");
                    sessionStorage.setItem("userSelectedNofesh", JSON.stringify(this.userSelectedNofesh));

                    this._showSaveSuccessMessage();
                    this._disableCheckedCheckboxes();
                    this._clearSessionOnReservationComplete(this.userSelectedNofesh.id_nofesh);

                    if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this._nofshonReservationTimerService.isTimerShown) {
                        this._nofshonReservationTimerService.stopTimer();
                        this._nofshonReservationTimerService.hideTimer();
                        console.log("End rishum - submit. Timer is stopped");
                    }
                }
                else {
                    window.scrollTo(0, 0);
                    this._userMessagesService.setErrorMessage("אירעה שגיאה בשמירת הנתונים");
                }
            },
                error => {
                    console.error(error);
                    window.scrollTo(0, 0);
                    this._userMessagesService.setErrorMessage("אירעה שגיאה בשמירת הנתונים");
                });
    }

    private _clearSessionOnReservationComplete(nofeshId: number): void {
        sessionStorage.removeItem("moed-rishum");
        sessionStorage.removeItem("nofshon-nirshamim");
        sessionStorage.removeItem("nofshon-tashlumim");
        sessionStorage.removeItem(`pirteyNofshimVisited_${nofeshId}`);
    }

    private _showSaveSuccessMessage(): void {
        let message = "הרישום בוצע בהצלחה";

        if (this.is_hamtana) {
            if (this.userSelectedNofesh.mimush >= 2)
                message = "הנך רשום בעדיפות שניה, אישור סופי ישלח על ידי הנהלת העמותה";
            else
                message += ". נרשמת לרשימת המתנה";
        }
        this._userMessagesService.showSnackBarSuccessMessage(message);
        this._userMessagesService.setSuccessMessage(message);
    }

    private _showCompletedReservationMessage(): void {
        const message = `הזמנתך ${this.userSelectedNofesh.isEditMode ? 'עודכנה' : 'נקלטה'} בהצלחה`;
        this._userMessagesService.setSuccessMessage(message);
        this._userMessagesService.showSnackBarSuccessMessage(message);
    }

    print() {
        this._userMessagesService.clearAll();

        setTimeout(() => {
            const originalStyles = this._hideSectionsForPrint();

            let hiddenOnPrint = document.getElementsByName("hiddenonprint");
            console.dir(hiddenOnPrint);
            for (let i = 0; i < hiddenOnPrint.length; i++) {
                hiddenOnPrint[i].style.display = "none";
            }

            window.print();

            this._showHiddenSectionsAfterPrint(originalStyles);
            if (this.userSelectedNofesh.isReservationCompleted) {
                this._showCompletedReservationMessage();
            }
            else if (this.userSelectedNofesh.id_reservation > 0) {
                this._showSaveSuccessMessage();
            }

            for (let i = 0; i < hiddenOnPrint.length; i++) {
                hiddenOnPrint[i].style.display = "inline";
            }
        }, 0);
    }

    private _hideSectionsForPrint(originalStyles: {} = {}): {} {
        const form: HTMLElement = document.querySelector("form");
        originalStyles["form"] = JSON.parse(JSON.stringify({ selector: "form", styles: form.style }));
        form.style.fontSize = "0.5em";

        const tableCells: NodeList = form.querySelectorAll("table.table tr td");
        originalStyles["tableCells"] = JSON.parse(JSON.stringify({ selector: "table.table tr td", styles: (tableCells[0] as HTMLElement).style }));
        tableCells.forEach(cell => {
            (cell as HTMLElement).style.fontSize = "2em";
        });

        const header: HTMLElement = document.querySelector("header");
        originalStyles["header"] = JSON.parse(JSON.stringify({ selector: "header", styles: header.style }));
        header.style.display = "none";

        const planAndDev: HTMLElement = document.querySelector("#planAndDev");
        originalStyles["planAndDev"] = JSON.parse(JSON.stringify({ selector: "#planAndDev", styles: planAndDev.style }));
        planAndDev.style.marginTop = "0";
        planAndDev.style.paddingTop = "0";

        const bContainer: HTMLElement = document.querySelector(".bContainer");
        originalStyles["bContainer"] = JSON.parse(JSON.stringify({ selector: ".bContainer", styles: bContainer.style }));
        bContainer.style.marginTop = "0";
        bContainer.style.paddingTop = "0";

        const stepsMenu: HTMLElement = document.querySelector("#menuDiv");
        originalStyles["stepsMenu"] = JSON.parse(JSON.stringify({ selector: "#menuDiv", styles: stepsMenu.style }));
        stepsMenu.style.display = "none";

        const footer: HTMLElement = document.querySelector("#section2");
        originalStyles["footer"] = JSON.parse(JSON.stringify({ selector: "#section2", styles: footer.style }));
        footer.style.display = "none";

        return originalStyles;
    }

    private _showHiddenSectionsAfterPrint(originalStyles: {}): void {
        const form = originalStyles["form"];
        (document.querySelector(form.selector) as HTMLElement).style.fontSize = form.styles.fontSize;

        const tableCells = originalStyles["tableCells"];
        (document.querySelector(tableCells.selector) as HTMLElement).style.fontSize = tableCells.styles.fontSize;

        const header = originalStyles["header"];
        (document.querySelector(header.selector) as HTMLElement).style.display = header.styles.display;

        const planAndDev = originalStyles["planAndDev"];
        (document.querySelector(planAndDev.selector) as HTMLElement).style.paddingTop = planAndDev.styles.paddingTop;
        (document.querySelector(planAndDev.selector) as HTMLElement).style.marginTop = planAndDev.styles.marginTop;

        const bContainer = originalStyles["bContainer"];
        (document.querySelector(bContainer.selector) as HTMLElement).style.paddingTop = bContainer.styles.paddingTop;
        (document.querySelector(bContainer.selector) as HTMLElement).style.marginTop = bContainer.styles.marginTop;

        const stepsMenu = originalStyles["stepsMenu"];
        (document.querySelector(stepsMenu.selector) as HTMLElement).style.display = stepsMenu.styles.display;

        const footer = originalStyles["footer"];
        (document.querySelector(footer.selector) as HTMLElement).style.display = footer.styles.display;
    }


    cancelReservation(): void {
        if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted && this._nofshonReservationTimerService.checkIfInMinimalPeriodToStopTimer(this.userSelectedNofesh.moed_rishum)) {
            this._nofshonReservationTimerService.stopTimer();
            this._nofshonReservationTimerService.hideTimer();
            console.log("End rishum - cancel reservation by user on minimal timer time. Timer is stopped");
        }

        this._nofshonimService.cancelNofshonReservation(this.userSelectedNofesh.id_nofesh).subscribe(() => {
            //this._nofshonimService.cancelNofshonReservation().subscribe(() => {
            this._nofshonimService.clearSessionOnCancelReservation(this.userSelectedNofesh.id_nofesh);

            if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this._nofshonReservationTimerService.isTimerShown && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted) {
                this._nofshonReservationTimerService.stopTimer();
                this._nofshonReservationTimerService.hideTimer();
                console.log("End rishum - cancel reservation by user. Timer is stopped");
            }

            const message = "ההזמנה בוטלה בהצלחה";
            this.snackBarRef = this._userMessagesService.showSnackBarSuccessMessage(message, null, this._userMessagesService.clearAll.bind(this._userMessagesService));
            this._userMessagesService.setSuccessMessage(message);
            this.navigateToNofeshPage();
        });
    }

    showConfirmCancelDialog() {
        let data;
        if (this.userSelectedNofesh.isReservationCompleted) {
            data = {
                title: "ביטול הזמנה",
                content: [
                    "האם לבטל את ההזמנה?",
                    "",
                    "עלות ביטול הזמנה בעמותה - 80 ₪ לנוסע.",
                    "לא ייגבה תשלום על ביטול נופש בהמתנה."
                ],
                confirmButtonText: "כן, אני רוצה לבטל",
                declineButtonText: "סגור"
            }
        }
        else {
            data = {
                title: "ביטול הזמנה",
                content: ["האם לבטל את ההזמנה?"]
            }
        }

        const dialogRef = this._confirmDialog.open(ConfirmDialogComponent, {
            width: "600px",
            data,
            hasBackdrop: true,
            disableClose: true,
            restoreFocus: true,
            closeOnNavigation: true
        });

        const dialogSubscription = this._confirmDialogService.confirm$.subscribe(() => {
            dialogRef.close();
            dialogSubscription.unsubscribe();
            this.cancelReservation();
        });

    }

    ngOnDestroy(): void {
        if (!this.snackBarRef) {
            this._userMessagesService.clearAll();
        }

        if (this.userSelectedNofesh && this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh)) {
            if (this._timeoutSubscription) {
                this._timeoutSubscription.unsubscribe();
            }
        }
    }

}
